export enum ArtifactTTL {
  INHERIT = -1,
  DISABLED = -2,
}

export function isInvalidTTLString(s: string) {
  const maxTTL = 1000000;
  if (/^\d+$/.test(s)) {
    return Number(s) < 1 || Number(s) > maxTTL;
  }
  return true;
}

export const ttlInputErrorMsg =
  'Please provide an integer between 1 and 1,000,000';
